import numeral from 'numeral';

export const setCurrency = (country: string) => {
    switch (country) {
        case 'UK': {
            numeral.localeData().currency.symbol = '£';
            break;
        }
        case 'Denmark': {
            numeral.localeData().currency.symbol = 'DKK ';
            break;
        }
        case 'Norway': {
            numeral.localeData().currency.symbol = 'kr. ';
            break;
        }
        case 'Switzerland': {
            numeral.localeData().currency.symbol = 'CHF ';
            break;
        }
        case 'UAE': {
            numeral.localeData().currency.symbol = 'AED ';
            break;
        }
        case 'Kuwait': {
            numeral.localeData().currency.symbol = 'KWD ';
            break;
        }
        case 'Qatar': {
            numeral.localeData().currency.symbol = 'QAR ';
            break;
        }
        case 'Thailand': {
            numeral.localeData().currency.symbol = '฿';
            break;
        }
        case 'Bermuda':
        case 'US': {
            numeral.localeData().currency.symbol = '$';
            break;
        }
        case 'Oman': {
            numeral.localeData().currency.symbol = 'OMR';
            break;
        }
        case 'Ireland':
        case 'Spain':
        case 'ES':
        case 'France':
        case 'Germany':
        default: {
            numeral.localeData().currency.symbol = '€';
            break;
        }
    }
};

export const getCurrency = () => {
    return numeral.localeData().currency.symbol;
};

export const getCurrencySymbol = (currencyCode: string) => {
    switch (currencyCode.toUpperCase()) {
        case 'GBP':
            return '£';
        case 'EUR':
            return '€';
        case 'USD':
            return '$';
        default:
            return currencyCode;
    }
};

/**
 * A helper method that's used to return the currency code based on the currency symbol
 * @returns a currency code
 */
export const getCurrencyCode = () => {
    const currencySymbol = getCurrency();
    switch (currencySymbol) {
        case '£':
            return 'GBP';
        case '$':
            return 'USD';
        case 'kr. ':
            return 'NOK';
        case '€':
            return 'EUR';
        // Thailand
        case '฿':
            return 'THB';
        default:
            return currencySymbol.toUpperCase().trim();
    }
};

// numeral cannot handle numbers < 1e-7. In that case format returns NaN.
export const handleSmallNumber = (n: number) => {
    return n > 1e-7 ? n : 0;
};
